import { Box, styled } from "@mui/material";
import { keyframes } from "@emotion/react";
import iconLoader from "../../assets/images/CrimeRisk.AI Final Logo.png"; // Assuming this is the loader icon

const Loader = ({ showBackdrop = false, showLoader, children }) => {
  return (
    <>
      {showLoader && (
        <LoaderContainer showbackdrop={String(showBackdrop)}>
          <LogoImage src={iconLoader} alt="Loader" />
        </LoaderContainer>
      )}
      {children}
    </>
  );
};

const blink = keyframes`
0%{
    opacity: 1;
}
50%{
    opacity: 0.2;
}
100%{
    opacity: 1;
    }
`;

const LoaderContainer = styled(Box)(({ showbackdrop }) => ({
  position: "absolute",
  zIndex: 1600,
  top: window.scrollY,
  left: 0,
  right: 0,
  height: "100vh",
  width: "100%",
  background: showbackdrop === "true" ? "#0000008a" : "#000000ac",
}));

const LogoImage = styled("img")(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  animation: `1s ${blink} ease-in-out infinite`,
  width: "400px",
}));

export default Loader;
